import React from "react";
import { Param, ParamTable } from "../Paramtable";
import { EndpointHeader } from "../Endpointheader";
import { CodeBlock } from "../Codeblock";
import { MethodBadge } from "../Methodbadge";

// ─── Params ───────────────────────────────────────────────────────────────

const QUERY_PARAMS: Param[] = [
  { name: "userId", type: "number", required: true, description: "User ID." },
  { name: "keyword", type: "string", required: true, description: "Trigger keyword." },
  { name: "responseText", type: "string", required: false, description: "Response text (for TEXT type)." },
];

const BODY_PARAMS: Param[] = [
  {
    name: "file",
    type: "file",
    required: false,
    description: "Media file (image, video, document). Required for non-text responses.",
  },
];

// ─── Code Blocks ──────────────────────────────────────────────────────────

const CURL = `curl 'https://apiwhat.empedance.com/api/chatbot/upload-rule?userId=1&keyword=Hi&responseText=hello' \\
  -H 'Authorization: Bearer <your_token>' \\
  -F 'file=@/path/to/file'`;

const RESPONSE_200 = `{
  "id": 12,
  "userId": 1,
  "keyword": "Hi",
  "responseText": "hello",
  "responseType": "TEXT",
  "mediaId": null,
  "mediaUrl": null,
  "createdAt": 1776252940499
}`;

// ─── Component ────────────────────────────────────────────────────────────

export const AddTrainBotRuleSection: React.FC = () => {
  return (
    <div>
      <div className="flex items-center gap-3 mb-2">
        <MethodBadge method="POST" />
        <h1 className="text-2xl font-bold">Add Train Bot Rule</h1>
      </div>

      <p className="text-sm text-white/70">
        Create a chatbot rule by mapping a keyword to a response.
      </p>

      <EndpointHeader
        method="POST"
        url="/api/chatbot/upload-rule?userId=1&keyword=Hi&responseText=hello"
      />

      <ParamTable title="Query Parameters" params={QUERY_PARAMS} />
      <ParamTable title="Request Body (Optional)" params={BODY_PARAMS} />

      {/* Info */}
      <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-800">
        <span className="font-semibold">💡 Tip:</span>  
        Use <b>responseText</b> for TEXT responses.  
        Use <b>file upload</b> for IMAGE / VIDEO / DOCUMENT responses.
      </div>

      <CodeBlock
        title="Request Example"
        variants={[{ label: "cURL", value: CURL }]}
      />

      <CodeBlock
        title="RESPONSE 200 · OK"
        variants={[{ label: "JSON", value: RESPONSE_200 }]}
      />

      {/* Notes */}
      <div className="mt-5 p-4 bg-gray-50 border rounded-xl text-sm text-gray-700">
        <p className="font-semibold mb-2">📌 Behavior:</p>
        <ul className="list-disc pl-5 text-xs space-y-1">
          <li>If file is uploaded → responseType auto becomes IMAGE/VIDEO/DOCUMENT</li>
          <li>If only text → responseType = TEXT</li>
          <li>Keyword matching is case-sensitive (depends on backend config)</li>
        </ul>
      </div>
    </div>
  );
};